/**
 *  one line only
 */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

const style = {
  container: {
    width: '100%',
  },
  content: {
    display: 'flex',
    flexWrap: 'nowrap',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  collapsedText: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  unCollapsedText: {
    wordBreak: 'break-all',
    whiteSpace: 'pre-wrap',
  },
  moreButton: {
    marginLeft: 5,
  },
  lessButton: {
    padding: 0,
  },
};

const ShowMore = ({ children, more, less }) => {
  const [isCollapsed, setCollapsedStatus] = useState(true);
  const [isEllipsis, setEllipsisStatus] = useState(true);
  const ref = useRef();

  const checkIsEllipsisActive = () => {
    if (!ref.current) {
      return false;
    }
    return ref.current.offsetWidth < ref.current.scrollWidth;
  };

  const toggleCollapsed = () => setCollapsedStatus(status => !status);

  useEffect(() => {
    setEllipsisStatus(checkIsEllipsisActive());
  }, [isCollapsed]);

  return (
    <div style={style.container}>
      <div style={style.content}>
        <span
          ref={ref}
          style={isCollapsed ? style.collapsedText : style.unCollapsedText}
        >
          {children}
        </span>
        {isEllipsis && isCollapsed && (
          <Button
            size="small"
            onClick={toggleCollapsed}
            type="link"
            style={style.link}
          >
            {more}
          </Button>
        )}
      </div>
      {!isCollapsed && (
        <Button
          size="small"
          onClick={toggleCollapsed}
          type="link"
          style={style.lessButton}
        >
          {less}
        </Button>
      )}
    </div>
  );
};

ShowMore.defaultProps = {
  more: 'Show more',
  less: 'Show less',
};

ShowMore.propTypes = {
  children: PropTypes.node.isRequired,
  more: PropTypes.string,
  less: PropTypes.string,
};

export default ShowMore;
